import React, { useEffect } from "react";

import { Clock16Regular, LinkMultiple16Regular } from "@fluentui/react-icons";
import { Text, mergeClasses } from "@fluentui/react-components";
import useStatusBarStyles from "./statusBar.styles";

import { useSelector } from "react-redux";
import { selectIsConnected, selectLastConnectionTime } from "./store";

enum MessageByStatus {
  Connected = "Last connected",
  Disconnected = "Not Connected",
}

const StatusBar = () => {
  const connectionEstablished = useSelector(selectIsConnected);
  const lastConnectionTime = useSelector(selectLastConnectionTime);

  const classes = useStatusBarStyles();

  const activeStyles = mergeClasses(classes.root, classes.activeStatusColor);

  useEffect(() => {}, [connectionEstablished]);

  return (
    <div className={!connectionEstablished ? classes.root : activeStyles}>
      <div className={classes.status}>
        <LinkMultiple16Regular />
        <Text className={classes.statusText} as="p" weight="medium" size={200}>
          {connectionEstablished ? MessageByStatus.Connected : MessageByStatus.Disconnected}
        </Text>
      </div>

      {connectionEstablished && (
        <div className={classes.status}>
          <Clock16Regular />

          <Text className={classes.statusText} as="p" weight="medium" size={200}>
            {lastConnectionTime}
          </Text>
        </div>
      )}
    </div>
  );
};

export default StatusBar;
